/**
 * The viewer's IANA timezone (e.g. `Europe/Chisinau`), sent on every Squad
 * chat turn.
 *
 * Squad's runtime containers run in UTC, so without this the agent answers
 * "what time is it?" / "is this due today?" from the server's clock — hours
 * off, and sometimes a different calendar day than the user's.
 *
 * Returns `''` when the browser can't tell us; the backend then falls back to
 * the last zone it saw for this user, and finally to UTC.
 */
export const browserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  } catch {
    return ''
  }
}
